<template>
  <header class="sitenav">
    <div class="">
      <div class="row">
        <div class="col-12 zindex10">
          <b-navbar toggleable="lg" type="light">
            <b-navbar-brand to="/">
              <img
                
                class="img-fluid zindex10"
                src="../assets/imgs/raspaygana/cementos-chihuahua.png"
                alt="Raspa y Gana"
              />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <template>
                  <!-- <b-nav-item class="fC btnrojo text-center pt-4 bold" href="/">Registrar ticket</b-nav-item>
                  
                  <b-nav-item
                    class="fC btnrojo text-center pt-4 bold"
                    to="/mis-participaciones"
                  >Mis participaciones</b-nav-item>

                  <b-nav-item class="fC btnrojo text-center pt-4 bold" href="/ganadores">Ganadores</b-nav-item> -->
                  
                 
                </template>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" to="/ganadores" v-if="userProfile == undefined || userProfile.email == undefined"> 
                  Ganadores                  
                </b-nav-item>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" href="./Centros de canje - CCH.pdf" target="_blank" v-if="userProfile == undefined || userProfile.email == undefined"> 
                  Centros de canje                  
                </b-nav-item>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" href="./Terminos y Condiciones CCH.pdf" target="_blank" v-if="userProfile == undefined || userProfile.email == undefined"> 
                  Términos y Condiciones                  
                </b-nav-item>

                

                
                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" to="/" v-if="userProfile != undefined && userProfile.email != undefined"> 
                  Registrar ticket
                  
                </b-nav-item>
                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" to="/mis-participaciones" v-if="userProfile != undefined && userProfile.email != undefined"> 
                  Mis participaciones
                  
                </b-nav-item>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" to="/ganadores" v-if="userProfile != undefined && userProfile.email != undefined"> 
                  Ganadores
                  
                </b-nav-item>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" href="./Centros de canje - CCH.pdf" target="_blank" v-if="userProfile != undefined && userProfile.email != undefined"> 
                  Centros de canje
                </b-nav-item>

                <b-nav-item class="fC btnrojo text-center pt-4 bold cerrarsesion" @click="logout()" v-if="userProfile != undefined && userProfile.email != undefined"> 
                  Cerrar sesión
                  
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";
import { mapState } from "vuex";
export default {
  data() {
    return {
      uid: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    try{
      this.uid = fb.auth.currentUser.uid;
      
    }catch(e){
      //
    }

    try{
      //console.log({useremail: this.userProfile.email})
    }catch(e){
      //
    }
    

    //console.log({user: this.userProfile})
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
